import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-foodmarket',
  templateUrl: './foodmarket.page.html',
  styleUrls: ['./foodmarket.page.scss'],
})
export class FoodmarketPage implements OnInit {
  public assets = environment.assets;
  public menuData: any = null;
  public loading = true;
  public error: string = null;
  public selectedDay: string = '0'; // 0 = Monday, 4 = Friday
  public allApiData: any = null; // Store all API data for inspection

  constructor(private http: HttpClient) {
    // Initialize to current day of week (Monday = 0, Friday = 4)
    const today = new Date();
    const day = today.getDay();
    const currentDayIndex = day === 0 ? 6 : day - 1; // Convert Sunday (0) to 6, Monday (1) to 0, etc.
    // Only set to current day if it's a weekday (0-4)
    this.selectedDay = currentDayIndex < 5 ? currentDayIndex.toString() : '0';
  }

  ngOnInit() {
    this.loadMenuData();
  }

  loadMenuData() {
    this.loading = true;
    this.error = null;
    this.http.get(environment.foodmarket_api).subscribe(
      (data: any) => {
        this.menuData = data;
        this.allApiData = data; // Store all data
        this.loading = false;
        // Log all available data for debugging
        console.log('Food Market API Data:', data);
      },
      (error) => {
        this.error = 'Failed to load menu data';
        this.loading = false;
        console.error('Error loading Food Market data:', error);
      }
    );
  }

  getCurrentWeekDay(): number {
    const today = new Date();
    const day = today.getDay();
    // Convert Sunday (0) to 6, Monday (1) to 0, etc.
    return day === 0 ? 6 : day - 1;
  }

  getDayName(index: string | number): string {
    const idx = typeof index === 'string' ? parseInt(index, 10) : index;
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
    return days[idx] || '';
  }

}

